import { generatePath } from 'react-router-dom';
import { locations } from '@/locations';
import { ASSET_STUDIO, FILTER_PARAMS } from '@/types/shared/navigation-tabs.enums';

type NavigateWithQueryFn = (
  path: string,
  options?: {
    excludeParams?: string[];
    replaceParams?: Record<string, string | null>;
    addParams?: Record<string, string>;
    allowAddNewParams?: boolean;
  }
) => void;

interface NavigateToAssetComponentsParams {
  siteId: string;
  assetId: string;
  componentId?: string;
  navigateWithQuery: NavigateWithQueryFn;
  replaceParams?: Record<string, string | null>;
  addParams?: Record<string, string>;
}

/**
 * Navigate to a specific component within an asset, or to all components if componentId is not provided
 * @param siteId - The site ID
 * @param assetId - The asset (machine) ID
 * @param componentId - The component ID to navigate to (optional, defaults to ALL_COMPONENTS)
 * @param navigateWithQuery - Navigation function from useQueryNavigation hook
 * @param replaceParams - Optional URL params to replace/remove (e.g., { drawer: null, itemId: null })
 */
export const navigateToAssetComponents = ({
  siteId,
  assetId,
  componentId,
  navigateWithQuery,
  replaceParams,
  addParams,
}: NavigateToAssetComponentsParams) => {
  const path = generatePath(locations.protected.sites.components, {
    siteId,
    machineId: assetId,
  });

  navigateWithQuery(path, {
    ...(replaceParams && { replaceParams }),
    addParams: {
      [FILTER_PARAMS.SELECTED_COMPONENT]: componentId || ASSET_STUDIO.ALL_COMPONENTS,
      ...addParams,
    },
  });
};
